"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeedsPaymentSetupFilter = void 0;
class NeedsPaymentSetupFilter {
    static transform(billingStatus) {
        return !!(billingStatus && billingStatus.paymentSetupRequired && !billingStatus.paymentSetupCompleted);
    }
}
exports.NeedsPaymentSetupFilter = NeedsPaymentSetupFilter;
angular.module('callX').filter('needsPaymentSetup', () => NeedsPaymentSetupFilter.transform);
